import FieldDetailList from '@platform-ui-common/components/FieldDetail/FieldDetailList.js';
import FieldDetail from '@platform-ui-common/components/FieldDetail/index.js';
import { DateFormat, formatDate } from '@platform-ui-common/utilities/format.js';
import { formatSimpleCaseStatus } from '@platform-ui-common/utilities/statuses.js';
import useUserApplications from '@platform-ui/application/hooks/useUserApplications.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { isThirdPartyUser } from '@platform-ui/common/utilities/applicantType.js';
import useCase from '@platform-ui/case/hooks/useCase.js';
import PanelWrapper from './PanelWrapper.js';

export default function ApplicationPanel(): JSX.Element {
  const { case_ } = useCase();
  const applications = useUserApplications();
  const application = applications.find((application) => application.case.id === case_.id);
  const status = formatSimpleCaseStatus(case_?.status);
  const { decisionReachedAt } = case_;
  const { user } = useAuth();
  const isThirdParty = isThirdPartyUser(user?.core);

  return (
    <PanelWrapper title={isThirdParty ? 'My Submission' : 'Application Details'} titleTag="h2">
      <FieldDetailList columns={1}>
        <FieldDetail label="SUBMISSION DATE">
          {application?.submittedAt
            ? formatDate(application.submittedAt, DateFormat.DateTime)
            : '-'}
        </FieldDetail>
        <FieldDetail label="APPLICATION ID">{application?.displayId}</FieldDetail>
        {!isThirdParty && <FieldDetail label="APPLICATION STATUS">{status}</FieldDetail>}
        {!isThirdParty && (
          <FieldDetail label="DECISION DATE">
            {decisionReachedAt ? formatDate(decisionReachedAt, DateFormat.Slashes) : '-'}
          </FieldDetail>
        )}
      </FieldDetailList>
    </PanelWrapper>
  );
}
